<input #nativeElem
       type="text"
       class="field"
       [name]="id"
       [value]="value"
       [placeholder]="label"
       (input)="onChange($event)"
       (focus)="onFocus()"
       (blur)="onBlur()"
       [readonly]="isReadonly"
       [required]="required ? '' : null"/>
<div class="icon"
     [class.selected]="inputFocused">
  <mat-icon>search</mat-icon>
</div>
